import { render, staticRenderFns } from "./collect1.vue?vue&type=template&id=3a26eaba&scoped=true&"
import script from "./collect1.vue?vue&type=script&lang=js&"
export * from "./collect1.vue?vue&type=script&lang=js&"
import style0 from "./collect1.vue?vue&type=style&index=0&id=3a26eaba&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./collect1.vue?vue&type=style&index=1&id=3a26eaba&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style2 from "./collect1.vue?vue&type=style&index=2&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a26eaba",
  null
  
)

export default component.exports